import React from 'react'
import PropTypes from 'prop-types'

const LogoutButton = (props) => (
	<button className="LogoutButton" onClick={props.click}><span>{props.text}</span></button>
)

LogoutButton.propTypes = {
	click: PropTypes.func,
	text: PropTypes.string.isRequired
}

export default LogoutButton


// WEBPACK FOOTER //
// ./src/components/UserLogoutControl/LogoutButton.js